import React, { useState } from "react";
import { useDraggable } from "@dnd-kit/core";
import { ResizeOverlay } from "./ResizeOverlay";

export function CanvasItem({ element, isEditable = false }) {
  const [resizing, setResizing] = useState(false);

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: element.id,
    disabled: !isEditable || resizing,
  });

  const finalX = element.layout.x + (isEditable && transform ? transform.x : 0);
  const finalY = element.layout.y + (isEditable && transform ? transform.y : 0);

  const style = {
    position: "absolute",
    left: finalX,
    top: finalY,
    width: element.layout.width,
    height: element.layout.height,
    zIndex: element.zIndex,
    touchAction: isEditable ? "none" : "auto",
    userSelect: "none",
    cursor: isEditable && !resizing ? "grab" : "default",
  };

  const handlePointerDown = (e) => {
    console.log("Pointer down on element:", element.id);
    if (isEditable && element.onSelect) {
      e.stopPropagation();
      element.onSelect(element.id);
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      id={element.id}
      onPointerDown={handlePointerDown}
      {...(isEditable && element.isSelected ? listeners : {})}
      {...(isEditable ? attributes : {})}
    >
      <ItemBox
        selected={element.isSelected && isEditable}
        element={element}
      />

      {isEditable && element.isSelected && (
        <ResizeOverlay element={element} setResizing={setResizing} />
      )}
    </div>
  );
}

function ItemBox({ element, selected }) {
  const { type, style: elementStyle = {} } = element;

  const baseStyle = {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    borderRadius: elementStyle.borderRadius ?? 0,
    backgroundColor: elementStyle.backgroundColor,
    boxShadow: elementStyle.boxShadow,
    border: selected
      ? "2px solid #1976d2"
      : elementStyle.borderWidth
        ? `${elementStyle.borderWidth}px solid ${elementStyle.borderColor || "#000"}`
        : "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  };

  if (type === "text") {
    return (
      <div
        style={{
          ...baseStyle,
          color: elementStyle.color,
          fontSize: elementStyle.fontSize,
          fontWeight: elementStyle.fontWeight,
          textAlign: elementStyle.textAlign,
          padding: 8,
          userSelect: "none",
        }}
      >
        {element.content?.text || "Text"}
      </div>
    );
  }

  if (type === "image") {
    return (
      <div style={baseStyle}>
        <img
          src={element.content?.src}
          alt={element.content?.alt || ""}
          draggable={false}
          style={{
            width: "100%",
            height: "100%",
            objectFit: elementStyle.objectFit || "contain",
            pointerEvents: "none",
          }}
        />
      </div>
    );
  }

  return null;
}
